const lightbox = document.querySelector('#lightbox');
const lighboxClose = lightbox.querySelector('.lightbox-close-wrapper');
const mediaElement = document.querySelector('.product-page--root .product-page--mobile-container product-media-carousel');
const htmlRootElement = document.documentElement;

function getElementTransform() {
	return mediaElement.querySelector('transition-root').style.transform;
}

function lightboxTransform (v) {
	lightbox.querySelector('transition-root').style.transform = v
}

mediaElement.addEventListener('click', () => {
	htmlRootElement.classList.add('nooverflow');
	lightboxTransform(getElementTransform());
	lightbox.classList.remove('hide');
})

lighboxClose.addEventListener('click', () => {
	htmlRootElement.classList.remove('nooverflow');
	lightbox.classList.add('hide');
})